import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from './AuthContext';
import { Navigate, replace, useLocation, useNavigate } from 'react-router-dom';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebaseconfig';
import { Navbar } from './NavBar';

export function VoteFans() {

    const location = useLocation()
    const { state } = useLocation()

    const navigate = useNavigate()

    const { user, loading, signOut } = useContext(AuthContext)

    const [categorySelect, setCategorySelect] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [participants, setParticipants] = useState([])

    const [selectedOptions, setSelectedOptions] = useState([]);

    useEffect(() => {

        // Set default back navigation to home page
        const handlePopState = (event) => {
            event.preventDefault();
            navigate("/", { replace: true });
        };

        window.addEventListener("popstate", handlePopState);

        // If user is still loading, return early to avoid bad rendering
        if (loading) {
            return
        }

        const checkCategory = async() => {

            try {
                if (user) {

                    // If user is logged in, retrieve the its document from the database
                    const docSnap = (await getDoc(doc(db, "users", user.uid))).data()

                    // check if user has selected a category
                    if (!docSnap.categorySelected) {

                        // if user selected no category -> set categorySelect to true
                        setCategorySelect(true)

                    } else if (docSnap.vote !== null) {

                        // if the user has already voted then:

                        // check for location state
                        if (state) {

                            // if state exists and user did not come from the thank-you page -> then redirect the user to thank-you page
                            // else leave the user in vote page
                            if (state.cameFrom !== "thx") {
                                navigate("/vote-fans-thank-you")
                                return
                            }

                        } else {

                            // if user came from any other page -> then redirect the user to thank-you page
                            navigate("/vote-fans-thank-you")
                            return
                        }

                        // set voting data based on already existing vote and fetch participants, then setCategorySelect to false
                        setSelectedOptions(docSnap.vote)
                        fetchParticipants(docSnap.category)
                        .then(() => {
                            setCategorySelect(false)
                        })

                    } else {

                        // fetch participants
                        fetchParticipants(docSnap.category)
                        .then(() => {
                            setCategorySelect(false)
                        })

                    }
                }
            } catch (error) {
                console.error(error)
                navigate('/', {replace: true})
                alert("Valamilyen hiba történt! Kérem próbálja újra később!")
                return
            }

            setIsLoading(false)

            return

        }

        checkCategory()

        return () => {window.removeEventListener("popstate", handlePopState)}
        
    }, [navigate, user, loading]);

    const fetchParticipants = async(category) => {

        const docData = (await getDoc(doc(db, "candidates", category.toString()))).data()

        // map candidates document to a list containing IDs and all the other data for rendering
        const new_participants_list = Object.keys(docData).map((key) => ({
            id: Number(key),
            ...docData[key]
        }))
        setParticipants(new_participants_list)

    }

    const handleCheckboxChange = (id) => {

        // if the item is already selected, remove it
        if (selectedOptions.includes(id)) {
            setSelectedOptions(selectedOptions.filter((item) => item !== id));
        } else {
            // if already two selections, do not add more
            if (selectedOptions.length >= 2) {
                return;
            }
            // add the newly selected candidate's id
            setSelectedOptions([...selectedOptions, id]);
        }
    };

    async function handleSubmit() {

        // If no option selected return
        if (selectedOptions.length < 1) {
            alert("Kérem válasszon legalább egy résztvevőt!")
            return
        }

        // update user's document with the vote
        await updateDoc(doc(db, "users", user.uid), {
            vote: selectedOptions
        })
        navigate("/vote-fans-thank-you", {replace: true})

    }

    async function handleCategorySelect (category) {

        if (category === 3) {
            alert("A döntőre való szavazás még nem elérhető!")
            return
        }

        // set user's category based on the selected category (passed in as arg)
        // setCategorySelect to false and fetch the participants of the new category
        await updateDoc(doc(db, "users", user.uid), {
            category: category,
            categorySelected: true
        })
        fetchParticipants(category)
        setCategorySelect(false)

    }

    async function changeCategory() {

        // confirm change of category (current vote will be lost)
        if(window.confirm("Biztosan meg szeretné változtatni a kategóriát? Az eddigi kategóriában leadott szavazatai törlésre kerülnek!")) {

            // setting category and participants to null
            // setCategorySelect to true -> redirects to <category chooser> page element
            await updateDoc(doc(db, "users", user.uid), {
                category: null,
                categorySelected: false,
                vote: null
            })

            setParticipants([])
            setSelectedOptions([])
            setCategorySelect(true)

        }
        return

    }

    // If user is still loading, return early to avoid bad rendering
    if (loading || isLoading) {
        return(<div>Betöltés... Kérem Várjon</div>)
    }

    return (
        user ? (

            <>

            <div className='main-container'>

                <Navbar text1="Zsűri Bejelentkezés" text2="Kijelentkezés" onClick2={signOut} second/>

                {categorySelect ? (
                    <div className='vote-container'>
                        <h1>Kérem válasszon kategóriát!</h1>
                        <div key={1} className='category-container' onClick={() => handleCategorySelect(1)}>
                            <p>1. Kategória<br/>7-10. osztály</p>
                        </div>
                        <div key={2} className='category-container' onClick={() => handleCategorySelect(2)}>
                            <p>2. Kategória<br/>11-12. osztály</p>
                        </div>
                        <div key={3} className='category-container' onClick={() => handleCategorySelect(3)}>
                            <p>2.Döntő<br/>Minden évfolyam</p>
                        </div>
                    </div>) : (
                    <div className='vote-container'>
                        <h1>Üdvözöljük a szavazási felületen!</h1>
                        <p>Kérem válasszon kettő résztvevőt!</p>
                        <button className='change-category-button' onClick={changeCategory}>Kategória megváltoztatása</button>
                        {participants.map((item) => {

                            const isChecked = selectedOptions.includes(item.id);
                            const disableCheckbox = !isChecked && selectedOptions.length >= 2;

                            return (
                            <div key={item.id} className="candidate-container">

                                <label className={`checkbox-container ${disableCheckbox ? "disabled" : ""}`}>
                                    <input
                                    type="checkbox"
                                    value={item.id}
                                    onChange={() => handleCheckboxChange(item.id)}
                                    checked={isChecked}
                                    disabled={disableCheckbox}
                                    className="checkbox-input"
                                    />
                                    <span className="custom-checkbox"></span>
                                </label>


                                <div className='candidate-name-container'>
                                    <p>{item.name} {item.class}</p>
                                </div>

                                <div className='candidate-points-container'>
                                    <p>Zsűri Pontszám:<br/>{item.judge_point}</p>
                                </div>

                                <div className='candidate-play-container'>
                                    <p>Előadott Mű:<br/>{item.play}</p>
                                </div>

                                <div className='video-container'>
                                    <video key={2} className='video' controls>
                                        <source src={`/videos/M Faktor kisfilm ${2}.mp4`} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                            </div>)                           
                        })}
                        <button className='submit-vote-button' onClick={handleSubmit}>Szavazat Leadása</button>
                    </div>
                )}

            </div>

            </>

        ) : (
            <Navigate to="/login-fans" state={{from: location.pathname, message: "Jelentkezzen be a szavazáshoz!"}} replace/>
        )
    );

}

